define("settings/templates/overview/display", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _templateFactory.createTemplateFactory)({
    "id": "lOpnwm6M",
    "block": "[[[8,[39,0],null,[[\"@focusTrap\",\"@close\"],[true,[30,0,[\"closeModal\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"account.overview.display.title\"],null]]],null],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,2],null,null,null],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,3],[[24,0,\"u--float--right\"]],[[\"@type\",\"@onClick\"],[\"outline\",[30,0,[\"closeModal\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,1],[\"shared_words.close\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\"]],[\"modal\"],false,[\"shared/modal\",\"t\",\"shared/locale\",\"shared/ui/button\"]]",
    "moduleName": "settings/templates/overview/display.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});